<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent()">
  @if (addressData ) {
    <form [formGroup]="addressGroup" (ngSubmit)="onSubmit()">
      <h1 class="bofa--heading is-4" #target>Address history</h1>
      @if (ukBasicDisclosureFlag && this.addressData.jobCountryId == 185 ) {
        <div>
          <mat-form-field class="bottom-space max-zoom field-space width_350" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Will you be working or studying in:</mat-label>
            <mat-select formControlName="ukDisclosure" required>
              <mat-option>Select</mat-option>
              <mat-option value="1">Scotland or Northern Ireland </mat-option>
              <mat-option value="2">Any country other than United Kingdom </mat-option>
              <mat-option value="3">England, Wales, or any crown dependency</mat-option>
            </mat-select>
            @if (ukDisclosure.hasError('required') ) {
              <mat-error>Please select Will you be working or studying in:
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      @if (showOusQuestion && !ousCase ) {
        <div>
          <div class="bottom-space">
            <div id="us-ous-radio-group" class="minor-list-space"><span><abbr title="required">* </abbr>Have you lived or
          worked in a country outside of the United States for 6 months or more within the last 5 years?</span>
        </div>
        <mat-radio-group (focusout)="ousOnBlur()" (focusin)="ousOnFocus()" class="bottom-space minor-radio-padding"
          aria-describedby="us-ous-radio-group" formControlName="haveYouLivedOUS"
          (change)="onHaveYouLivedOUSChange($event)" aria-required="true" required>
          <mat-radio-button class="minor-list-space radio-padding field-space" matInput [value]=1
          name="haveYouLivedOUS">Yes</mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput [value]=0 name="haveYouLivedOUS">No</mat-radio-button>
          @if ((submit.value && haveYouLivedOUS.hasError('required')) || check) {
            <mat-error>Please select Have you
              lived or
              worked in a country outside of the United States for 6 months or more within the last 5 years?
            </mat-error>
          }
        </mat-radio-group>
      </div>
    </div>
  }
  @if (ousCase && this.addressData.jobCountryId != 78) {
    <div>
      <div class="bottom-space">
        <div id="ous-radio-group" class="minor-list-space"><span><abbr title="required">* </abbr>Have you lived or
      worked in a country outside of {{jobCountry}} for 6 months or more within the last 5 years?</span>
    </div>
    <mat-radio-group class="bottom-space minor-radio-padding" aria-describedby="ous-radio-group"
      formControlName="haveYouLivedOutsideJobCountry" (change)="onHaveYouLivedOutsideJobCountryChange($event)"
      aria-required="true" required>
      <mat-radio-button class="minor-list-space radio-padding field-space" matInput [value]=1
      name="haveYouLivedOutsideJobCountry">Yes</mat-radio-button>
      <mat-radio-button class="minor-radio-padding" matInput [value]=0
      name="haveYouLivedOutsideJobCountry">No</mat-radio-button>
      @if ((submit.value && haveYouLivedOutsideJobCountry.hasError('required')) || check) {
        <mat-error>Please select
          Have you lived or worked in a country outside of the {{jobCountry}} for 6 months or more within the last 5
          years?
        </mat-error>
      }
    </mat-radio-group>
  </div>
</div>
}
<div class="bofa--alert has-background cool-gray-5 has-padding ">
  <span class="padding_10">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="information icon">
      <g data-name="ICON OUTLINES">
        <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
        <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
      <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
    </svg>
  </span>
  <span class="font-size_14">{{addressInstruction}}</span>
</div>
<div [class.changeDisplay]="addressChange" class="flex-container">
  <div class="fx-flex-40">
    <div class="is-taller">
      <div class="level">
        <div class="level-item">
          <h2 class="bofa--heading is-6 flex-heading">Enter your address history</h2>
        </div>
      </div>
    </div>
    @for (addressForm of addressList.controls; track addressForm; let i = $index) {
      <div [formGroup]="addressForm">
        <div>
          @if (step === i) {
            <mat-accordion multi="true">
              <mat-expansion-panel [class.border]="border" [expanded]="step === i" [hideToggle]="true"
                (opened)="setStep(i)" class="af-mat-card mat-elevation-z panel-width">
                <mat-expansion-panel-header class="mat-expansion outlined background-color-rgba">
                  <mat-panel-title>
                    Address {{i+1}}
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="float_right_cursor_pointer_margin-left_auto">
                      <button type="button" tabindex="0" (keyup.enter)="deleteClick(i)" (click)="deleteClick(i)"
                        class="icon-button" aria-label="Remove entire address {{i+1}}">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="height-Width_24" aria-label="remove address">
                          <g data-name="24 x 24 BOX">
                            <rect fill="none" width="24" height="24"/>
                          </g>
                          <g data-name="ICON OUTLINE">
                            <polygon fill="#e31837" points="21 3.707 20.293 3 12 11.293 3.707 3 3 3.707 11.293 12 3 20.293 3.707 21 12 12.707 20.293 21 21 20.293 12.707 12 21 3.707"/>
                          </g>
                        </svg>
                        <span class="bofa--skiplink">Remove</span>
                      </button>
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <!-- set focus when pressing Add button -->
                <div tabindex="-1" #addElement class="bofa--skiplink">
                </div>
                <div class="margin-top_1em">
                  <div class="bottom-space">
                    <div class="minor-list-space" id="current-radio-group"><span><abbr title="required">* </abbr>Is this
                  your current address?</span></div>
                  <mat-radio-group (focusout)="currentOnBlur(i)" (focusin)="currentOnFocus(i)"
                    aria-describedby="current-radio-group" formControlName="isCurrentAddress" aria-required="true"
                    required>
                    <mat-radio-button class="minor-list-space radio-padding" value="1" name="isCurrentAddress">Yes
                    </mat-radio-button>
                    <mat-radio-button value="0" name="isCurrentAddress">No</mat-radio-button>
                    @if ((submit.value && addressForm.controls.isCurrentAddress.hasError('required')) || addressForm.controls.checkTwo.value) {
                      <mat-error
                        >
                        Please select is this your current address?
                      </mat-error>
                    }
                  </mat-radio-group>
                  <!-- Hidden divs are for screen readers -->
                  <div class="bofa--skiplink">
                    @if (submit.value && addressForm.controls.isCurrentAddress.hasError('required') || addressForm.controls.checkTwo.value) {
                      <mat-error
                        >
                      Please select Is this your current address? </mat-error>
                    }
                  </div>
                </div>
              </div>
              <div class="form-field-wrapper">
                <label class="field-label" for="start-date"><abbr title="required">* </abbr>Start of residency (a.k.a.
              date you moved in)</label>
              <mat-form-field class="max-zoom field-space date-error-space hint-padding width_350"
                hideRequiredMarker>
                <input matInput id="start-date" [matDatepicker]="startDatePicker" [min]="minDate" [max]="maxDate"
                  time="false" formControlName="startDate" required maxlength="100">
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  @if (addressForm.controls.startDate.errors) {
                    <mat-error>Please enter valid start of residency in
                      the format mm/dd/yyyy
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              @if (addressForm.controls.isCurrentAddress.value === '0' ) {
                <div>
                  <div>
                    <label class="field-label" for="end-date"><abbr title="required">* </abbr>End of residency (a.k.a.
                  date you moved out)</label>
                  <mat-form-field class="max-zoom field-space date-error-space hint-padding width_350"
                    hideRequiredMarker>
                    <input matInput id="end-date" [matDatepicker]="endDatePicker" [min]="minDate" [max]="maxDate"
                      time="false" formControlName="endDate" required maxlength="100">
                      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #endDatePicker></mat-datepicker>
                      <mat-hint>Format mm/dd/yyyy</mat-hint>
                      @if (addressForm.controls.endDate.errors) {
                        <mat-error>Please enter valid end of residency in the
                          format mm/dd/yyyy
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              }
              <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr>Street address</mat-label>
                <input matInput formControlName="streetAddress1" required maxlength="100">
                <mat-error>Please enter a valid address</mat-error>
              </mat-form-field>
              <div class="non-required minor-list-space">
                <mat-form-field class="max-width width_300">
                  <mat-label>More street address (if applicable)</mat-label>
                  <input matInput formControlName="streetAddress2" maxlength="100">
                  <mat-error>Please enter a valid address</mat-error>
                </mat-form-field>
              </div>
              <div class="non-required minor-list-space margin-top_1em">
                <mat-form-field class="max-width width_300">
                  <mat-label>More street address (if applicable)</mat-label>
                  <input matInput formControlName="streetAddress3" maxlength="100">
                  <mat-error>Please enter a valid address</mat-error>
                </mat-form-field>
              </div>
              <mat-form-field class="max-zoom field-space width_350 margin-top_1em" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr>Zip code/Postal code</mat-label>
                <input matInput formControlName="zipCode" maxlength="13" required>
                <mat-error>Please enter a valid zip code/postal code</mat-error>
              </mat-form-field>
              <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr> City/Town/Province</mat-label>
                <input matInput formControlName="city" maxlength="100" required>
                <mat-error>Please enter a valid City/Town/Province</mat-error>
              </mat-form-field>
              <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr>Country</mat-label>
                <mat-select formControlName="country" required>
                  <mat-option>Select</mat-option>
                  @for (country of addressData.countryLookup | keyvalue : valueAscOrder; track country) {
                    <mat-option
                      [value]="country.key">
                      {{country.value}}
                    </mat-option>
                  }
                </mat-select>
                <mat-hint class="bofa--skiplink">
                  <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                  {{ dropDownScreenReaderCountry(addressForm) }}
                </mat-hint>
                @if (addressForm.controls.country.hasError('required')) {
                  <mat-error>Please select Country
                  </mat-error>
                }
              </mat-form-field>
              @if (addressForm.controls.country.value == 186) {
                <mat-form-field class="max-zoom field-space width_350"
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>State</mat-label>
                  <mat-select formControlName="usState" required>
                    <mat-option>Select</mat-option>
                    @for (us of addressData.usStateLookup | keyvalue : valueAscOrder; track us) {
                      <mat-option [value]=us.key>
                        {{us.value}}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderState(addressForm) }}
                  </mat-hint>
                  @if (addressForm.controls.usState.hasError('required')) {
                    <mat-error>Please select State
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (addressForm.controls.country.value != 186) {
                <div class="non-required bottom-space">
                  <mat-form-field class="max-width width_300">
                    <mat-label>State</mat-label>
                    <input matInput formControlName="state" maxlength="30">
                    @if (addressForm.controls.state.hasError('required')) {
                      <mat-error>Please enter a valid
                      state</mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              @if ((addressForm.controls.usState.value !== '5' || addressForm.controls.isCurrentAddress.value !== '1') && this.addressData.jobCountryId !== 78) {
                <mat-form-field
                  class="max-zoom field-space" class="padding-bottom_10_width_350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>County</mat-label>
                  <input placeholder="Enter 'N/A' if not applicable" class="margin-top_2em" matInput
                    formControlName="county" maxlength="100" required>
                    @if (addressForm.controls.county.hasError('required')) {
                      <mat-error>Please enter a valid
                      County</mat-error>
                    }
                  </mat-form-field>
                }
                @if (addressForm.controls.usState.value === '5' && addressForm.controls.isCurrentAddress.value === '1' && this.addressData.jobCountryId !== 78) {
                  <mat-form-field
                    class="max-zoom field-space width_350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>County</mat-label>
                    <mat-select formControlName="californiaCounty" required>
                      <mat-option>Select</mat-option>
                      @for (county of addressData.countyLookup | keyvalue : valueAscOrder; track county) {
                        <mat-option
                          [value]="county.key">
                          {{county.value}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (addressForm.controls.californiaCounty.hasError('required')) {
                      <mat-error>Please select
                      County</mat-error>
                    }
                  </mat-form-field>
                }
                @if (addressForm.controls.californiaCounty.value === '19') {
                  <div class="margin-top_1em">
                    <div class="bottom-space">
                      <div class="bottom-space">
                        <button type="button" class="bofa--button secondary outlined"
                          title="Download Los Angeles Unincorporated PDF" (click)="downloadLADocument()">Download Los
                        Angeles Unincorporated PDF</button>
                      </div>
                      <div class="minor-list-space" id="la-radio-group"><span><abbr title="required">* </abbr>Do you
                    currently live in one of these unincorporated areas?</span></div>
                    @if (addressForm.controls.californiaCounty.value === '19') {
                      <mat-radio-group
                        aria-describedby="la-radio-group" formControlName="isLACounty" aria-required="true" required>
                        <mat-radio-button class="minor-list-space radio-padding" value="1" name="isLACounty">Yes
                        </mat-radio-button>
                        <mat-radio-button value="0" name="isLACounty">No</mat-radio-button>
                        @if ((submit.value && addressForm.controls.isLACounty.hasError('required'))  || addressForm.controls.checkTwoCounty.value) {
                          <mat-error
                            >Please
                            select do you currently live in one of these unincorporated areas?
                          </mat-error>
                        }
                      </mat-radio-group>
                    }
                  </div>
                </div>
              }
              <!-- ous fields start -->
              @if (!ousCase && haveYouLivedOUS.value === 1 && addressForm.controls.country.value !== '186') {
                <div>
                  <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>This location is a Military base</mat-label>
                    <mat-select formControlName="militaryBase" required>
                      <mat-option>Select</mat-option>
                      @for (militaryQuestion of militaryQuestions ; track militaryQuestion) {
                        <mat-option [value]="militaryQuestion.id">
                          {{militaryQuestion.value}}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ addressForm.controls.militaryBase.value }}
                    </mat-hint>
                    @if (addressForm.controls.militaryBase.hasError('required') ) {
                      <mat-error>Please select if the
                        location is a Military Base.
                      </mat-error>
                    }
                  </mat-form-field>
                  @if (addressForm.controls.showBirthPlace.value) {
                    <div>
                      <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Country of Birth</mat-label>
                        <input matInput formControlName="countryOfBirth" maxlength="50" required>
                        <mat-error>Please enter a valid country of birth.</mat-error>
                      </mat-form-field>
                      <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Town of Birth</mat-label>
                        <input matInput formControlName="townOfBirth" maxlength="50" required>
                        <mat-error>Please enter a valid town of birth.</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  <!-- mother name -->
                  @if (addressForm.controls.showMotherName.value) {
                    <div>
                      <mat-form-field class="max-zoo field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Mother's First Name</mat-label>
                        <input matInput formControlName="motherFirstName" maxlength="50" required>
                        <mat-error>Please enter a valid mother's first name.</mat-error>
                      </mat-form-field>
                      <div class="non-required middle-width minor-list-space">
                        <mat-form-field class="max-width width_300">
                          <mat-label>Mother's Middle Name</mat-label>
                          <input matInput formControlName="motherMiddleName" maxlength="50">
                          <mat-error>Please enter a valid mother's middle name.</mat-error>
                        </mat-form-field>
                      </div>
                      <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Mother's Last Name</mat-label>
                        <input matInput formControlName="motherLastName" maxlength="50" required>
                        <mat-error>Please enter a valid mother's last name.</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  <!-- mother maiden name -->
                  @if (addressForm.controls.showMotherMaidenName.value) {
                    <div>
                      <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Mother's Maiden Name (Last)</mat-label>
                        <input matInput formControlName="motherMaidenName" maxlength="50" required>
                        <mat-error>Please enter a valid mother's maiden name.</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  <!-- fathers name -->
                  @if (addressForm.controls.showFatherName.value) {
                    <div>
                      <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Father's First Name</mat-label>
                        <input matInput formControlName="fatherFirstName" maxlength="50" required>
                        <mat-error>Please enter a valid father's first name.</mat-error>
                      </mat-form-field>
                      <div class="non-required middle-width minor-list-space">
                        <mat-form-field class="max-width width_300">
                          <mat-label>Father's Middle Name</mat-label>
                          <input matInput formControlName="fatherMiddleName" maxlength="50">
                          <mat-error>Please enter a valid father's middle name.</mat-error>
                        </mat-form-field>
                      </div>
                      <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Father's Last Name</mat-label>
                        <input matInput formControlName="fatherLastName" maxlength="50" required>
                        <mat-error>Please enter a valid father's last name.</mat-error>
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
              @if (this.addressData.jobCountryId === 78) {
                <div>
                  <div class="width_50_padding-left_5">
                    <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Address Proof Documentation</mat-label>
                      <mat-select required formControlName="attachementTypeId"
                        [disabled]="addressForm.controls.mongoAttachmentId.value !=''">
                        <mat-option>Select</mat-option>
                        @for (a of addressData.gbsAddressHisProofAttachmentList; track a) {
                          <mat-option
                            [value]=a.attachmentId>
                            {{a.attachmentName}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="width_50_padding-left_5">
                    <button type="button" class="float_right" class="bofa--button secondary"
                      [disabled]="addressForm.controls.mongoAttachmentId.value !==''"
                    (click)="openFileDialog(true ,addressForm.controls.attachementTypeId.value,'H')">Attach</button>
                  </div>
                </div>
              }
              <div class="is-taller remove-button-align">
                <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                address</button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    </div>
  }
</div>
<!-- Horizontal view -->
@if (!addressChange) {
  <div class="padding-left_70 fx-flex-60">
    <div [class.sticky]="sticky" class="max-width_535" [style.overflow]="'auto'" #stickyDiv>
      <div class="is-taller">
        <div class="level">
          <div class="width_50_padding-left_5 ">
            <h2 id="review-address-horizontal" class="bofa--heading is-6 flex-heading">Review your address
            history</h2>
          </div>
          <div class="width_50_padding-left_5" (keyup.enter)="scroll(target)" (click)="scroll(target)"> <button
            #addButtonElement [disabled]="addressList.invalid" type="button" class="float_right"
          class="bofa--button secondary" (click)="onAddAddress()">Add Address</button>
        </div>
      </div>
    </div>
    <div>
      @if (listCheck) {
        <mat-selection-list aria-label="Address History Selection List" aria-describedby="review-address-horizontal"
          (selectionChange)="handleSelection($event)">
          @for (addressForm of addressList.controls; track addressForm; let i = $index) {
            <mat-list-option [value]="i"
              [selected]="step === i" (click)="scroll(target)" (click)="focusTarget()" (keyup.enter)="scroll(target)"
              (keyup.enter)="focusTarget()">
              <div class="is-taller">
                <div class="level">
                  <div class="width_5_padding-left_5_margin-right_5">
                    @if (!addressForm.invalid) {
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="check completed address">
                          <g data-name="24 x 24 BOX"><rect fill="none" width="24" height="24"/></g>
                          <g data-name="ICON OUTLINE"><polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/></g>
                        </svg>
                      </span>
                    }
                    @if (addressForm.invalid) {
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete address">
                          <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                          <rect fill="none" width="24" height="24"/>
                        </svg>
                      </span>
                    }
                    <span class="padding-left_10">{{i+1}}</span>
                  </div>
                  <div class="width_15_margin-left_10_margin-right_10"> @if (addressForm.controls.isCurrentAddress.value === 1) {
                    <span
                    > (Current) </span>
                  }
                </div>
                <div class="width_35_max-width_40_overflow_hidden_white-space_nowrap_padding-left_15">
                  {{addressForm.controls.streetAddress1.value | slice:0:20}}
                </div>
                <div class="width_45_padding-left_10_padding-top_5_padding-bottom_5">
                  {{addressForm.controls.startDate.value | dateFormat }}
                  @if (addressForm.controls.isCurrentAddress.value === '0') {
                    <span> @if (addressForm.controls.endDate.value!=null) {
                      <span
                        > -
                      </span>
                    }{{addressForm.controls.endDate.value | dateFormat }} </span>
                  }
                </div>
              </div>
            </div>
            <mat-divider aria-hidden="true" class="field-space"></mat-divider>
          </mat-list-option>
        }
      </mat-selection-list>
    }
  </div>
</div>
</div>
}
<!-- Vertical view -->
@if (addressChange) {
  <div class="fx-flex-60">
    <div class="is-taller">
      <div class="level">
        <div class="width_50_padding-left_5 ">
          <h2 id="review-address-vertical" class="bofa--heading is-6">Review your address
          history</h2>
        </div>
        <div class="width_50_padding-left_5" (keyup.enter)="scroll(target)" (click)="scroll(target)"> <button
          #addButtonElement [disabled]="addressList.invalid" type="button" class="float_right"
          class="bofa--button secondary" (click)="onAddAddress()">Add
        Address</button>
      </div>
    </div>
  </div>
  <div>
    @if (listCheck) {
      <mat-selection-list aria-disabled="false" aria-label="Address History Selection List" aria-describedby="review-address-vertical"
        (selectionChange)="handleSelection($event)">
        @for (addressForm of addressList.controls; track addressForm; let i = $index) {
          <mat-list-option [value]="i"
            [selected]="step === i" (click)="scroll(target)" (click)="focusTarget()" (keyup.enter)="scroll(target)"
            (keyup.enter)="focusTarget()">
            <div class="is-taller">
              <div class="level">
                <div class="width_5_padding-left_5_margin-right_5">
                  @if (!addressForm.invalid) {
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="check completed address" class="review-icon">
                        <g data-name="24 x 24 BOX">
                          <rect fill="none" width="24" height="24"/>
                        </g>
                        <g data-name="ICON OUTLINE">
                          <polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/>
                        </g>
                      </svg>
                    </span>
                  }
                  @if (addressForm.invalid) {
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete address">
                        <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                        <rect fill="none" width="24" height="24"/>
                      </svg>
                    </span>
                  }
                  <span class="padding-left_10">{{i+1}}</span>
                </div>
                <div class="width_15_margin-left_10_margin-right_10"> @if (addressForm.controls.isCurrentAddress.value === 1) {
                  <span
                  > (Current) </span>
                }
              </div>
              <div class="width_35_max-width_40_overflow_hidden_white-space_nowrap_padding-left_15">
                {{addressForm.controls.streetAddress1.value | slice:0:20}}
              </div>
              <div class="width_45_padding-left_10_padding-top_5_padding-bottom_5">
                {{addressForm.controls.startDate.value | dateFormat }}
                @if (addressForm.controls.isCurrentAddress.value === '0') {
                  <span> @if (addressForm.controls.endDate.value!=null) {
                    <span
                      > -
                    </span>
                  }{{addressForm.controls.endDate.value | dateFormat }} </span>
                }
              </div>
            </div>
          </div>
          <mat-divider aria-hidden="true" class="field-space"></mat-divider>
        </mat-list-option>
      }
    </mat-selection-list>
  }
</div>
</div>
}
</div>
@if (!ousCase && (haveYouLivedOUS.value === 1 && ousMilitaryCheck)) {
  <div class="margin-top_1em">
    <mat-divider aria-hidden="true"></mat-divider>
    <div class="flex-change fx-flex-40">
      <h2 class="bofa--heading is-4 flex-heading">Required Documentation</h2>
      <span class="min-font">Please download using the links below. Completed
        documents must be uploaded on the Certification tab prior to
      submitting the form. </span>
      @for (ousAttachemt of ousAttachmentList; track ousAttachemt) {
        <mat-list>
          @if (ousAttachemt.downloadble != '1' ) {
            <p class="padding_8_16_0 has-no-margin" mat-list-item> {{
            ousAttachemt.attachmentName }} </p>
          }
          @if (ousAttachemt.downloadble == '1' ) {
            <a class="a-mat-list" mat-list-item target="_blank"
              rel="noopener noreferrer"
              href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID={{ousAttachemt.attachmentId}}&verifyId={{verifyId.value}}"
              aria-label="download {{ousAttachemt.attachmentName}}">
            {{ ousAttachemt.attachmentName }} </a>
          }
        </mat-list>
      }
    </div>
  </div>
}
@if (((haveYouLivedOutsideJobCountry.value === 1 && outsideJobCountryDocument === 1) || requiredOusAttachmentList)) {
  <div class="margin-top_1em"
    >
    <mat-divider aria-hidden="true"></mat-divider>
    <div class="flex-change fx-flex-40 bottom-space">
      <h2 class="bofa--heading is-4 flex-heading">Required Documentation</h2>
      @if (haveYouLivedOutsideJobCountry.value === 1) {
        <p class="padding_8_16_0 has-no-margin">Additional Country ID
        Type/Additional Country ID Number </p>
      }
      @for (ousAttachemt of requiredOusAttachmentList; track ousAttachemt) {
        <mat-list>
          @if (ousAttachemt.downloadble != '1' ) {
            <p class="padding_8_16_0 has-no-margin" mat-list-item> {{
            ousAttachemt.attachmentName }} </p>
          }
          @if (ousAttachemt.downloadble == '1' ) {
            <a class="a-mat-list" mat-list-item target="_blank"
              rel="noopener noreferrer"
              href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID={{ousAttachemt.attachmentId}}&verifyId={{verifyId.value}}"
              aria-label="download {{ousAttachemt.attachmentName}}">
            {{ ousAttachemt.attachmentName }} </a>
          }
        </mat-list>
      }
    </div>
  </div>
}
@if (this.addressData.jobCountryId == 78) {
  <div>
    <div class="table-container bottom-space margin-top_1em">
      <span class="hide" id="tableDescription">Attached files</span>
      <table mat-table aria-labelledby="tableDescription" [dataSource]="dataSource">
        <ng-container matColumnDef="fileName">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>File Name</th>
          <td mat-cell *matCellDef="let element">
            <button type="button" class="bofa--button secondary outlined" title="Download Attachment {{element.fileName}}"
              aria-label="download {{element.fileName}}"
              (click)="downloadAttachment(element.mongoAttachmentId, element.fileName)">{{element.fileName}}
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="descOfFileName">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element"> {{element.descOfFileName}}</td>
        </ng-container>
        <ng-container matColumnDef="fileType">
          <th scope="col" mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element"> {{element.fileType}} </td>
        </ng-container>
        <ng-container matColumnDef="fileSize">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Size (In Bytes)</th>
          <td mat-cell *matCellDef="let element"> {{element.fileSize}} </td>
        </ng-container>
        <ng-container matColumnDef="attachedBy">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Attached by</th>
          <td mat-cell *matCellDef="let element"> {{element.attachedBy}} </td>
        </ng-container>
        <ng-container matColumnDef="attachedDateString">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Date attached</th>
          <td mat-cell *matCellDef="let element"> {{element.attachedDateString}} </td>
        </ng-container>
        <ng-container matColumnDef="remove">
          <th scope="col" class="text-center" mat-header-cell *matHeaderCellDef>Action</th>
          <td class="text-center" mat-cell *matCellDef="let element">
            @if (!formSubmitted) {
              <button
                tabindex="0"
                type="button"
                (click)="removeAttachment(element.mongoAttachmentId)"
                (keyup.enter)="removeAttachment(element.mongoAttachmentId)"
                class="af-anchor">
                Remove <span class="hide">&nbsp;{{ element.fileName }}</span>
              </button>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns ; "></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator aria-label="Attached files pagination" [pageSizeOptions]="[ 10, 20 ]"
      showFirstLastButtons></mat-paginator>
    </div>
  </div>
}
</form>
} @else {
  Loading Address history...
}
</div>

